// src/hooks/useTraceability.js
import { useState, useEffect, useCallback } from 'react';
import service from '../services/traceabilityService';

export function useTraceability(limit, search = {}) {
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const searchKey = JSON.stringify(search);

  const fetchPage = useCallback(
    async (pageToFetch) => {
      const token = localStorage.getItem('token');
      try {
        const resp = await service.getLogs(pageToFetch, limit, token, JSON.parse(searchKey));
        setLogs(resp.data.logs);
        setTotalPages(resp.data.totalPages);
      } catch (err) {
        console.error('Error fetching traceability logs:', err);
      }
    },
    [limit, searchKey]
  );

  // Reset to page 1 whenever search changes
  useEffect(() => {
    setPage(1);
  }, [searchKey]); // eslint-disable-line react-hooks/exhaustive-deps

  // Fetch whenever page or fetchPage changes
  useEffect(() => {
    fetchPage(page);
  }, [fetchPage, page]);

  return { logs, page, totalPages, setPage, fetchPage };
}
